export default {
	specialists(state) {
		return state.specialists
	},
}
